import React, { useState, useEffect } from 'react';
import '../styles/Home.css';
import { Github, Linkedin, Mail, FileMinus } from 'lucide-react';
import resume from '../assets/AnaiysaaResume2026.pdf';
import AutoPause from '../components/AutoPause';
import Video from '../assets/videos/videoBackground.MP4';
import CameraFrame from '../assets/images/camera_frame.png';

const socialLinks = [
  { name: 'GitHub',   url: 'https://github.com/anaiysaa',                icon: Github   },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/in/anaiysaadeswal/', icon: Linkedin },
  { name: 'Email',    url: 'mailto:adeswal@purdue.edu',                   icon: Mail     },
  { name: 'Resume',   url: resume,                                        icon: FileMinus },
];

function useTimestamp() {
  const [time, setTime] = useState('');
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      const s = String(now.getSeconds()).padStart(2, '0');
      setTime(`${h}:${m}:${s}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}

function Home() {
  const timestamp = useTimestamp();

  return (
    <section id="home">
      <div className="home-top-fill" aria-hidden="true" />
      <div className="section-stripe" aria-hidden="true" />
      <div className="home-hero">

        {/* ── Left: text ── */}
        <div className="home-left">
          <div className="home-eyebrow">Computer Science · Purdue University · AI / ML</div>
          <div className="home-name-block">
            <div className="home-script">Anaiysaa</div>
            <div className="home-surname">Deswal</div>
          </div>
          <div className="home-subtitle">
            Building technology that creates meaningful impact —
            specializing in AI, machine learning &amp; software engineering.
          </div>
          <div className="home-divider" />
          <div className="home-social">
            {socialLinks.map(({ name, url, icon: Icon }) => (
              <a key={name} href={url} target="_blank" rel="noopener noreferrer" title={name} className="home-social-icon">
                <Icon size={19} /><span>{name}</span>
              </a>
            ))}
          </div>
        </div>

        {/* ── Right: camera ── */}
        <div className="cam-wrap">

          {/* Clipped screen box — video + HUD strictly inside screen area */}
          <div className="cam-screen-box">
            <AutoPause src={Video} className="cam-video" />
            <div className="cam-hud">
              <div className="cam-hud-tl">
                <span className="cam-rec-dot" />
                <span className="cam-rec-label">REC</span>
              </div>
              <div className="cam-hud-tr">{timestamp}</div>
              <div className="cam-hud-bl">AUTO</div>
              <div className="cam-hud-br">▮▮▮▯</div>
              <div className="cam-corner cam-tl" />
              <div className="cam-corner cam-tr" />
              <div className="cam-corner cam-bl" />
              <div className="cam-corner cam-br" />
            </div>
          </div>

          {/* Real camera PNG on top — transparent screen lets box show through */}
          <img src={CameraFrame} className="cam-img" alt="" />
        </div>

      </div>
    </section>
  );
}

export default Home;
